// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"6111e971","113":"a3593786","296":"8f4e72fa","330":"4624480e","458":"33d2206c","526":"114b0256","685":"95ad6ceb","705":"80b2bf27","797":"c9fc40f5","801":"c87133d9","934":"0af4c46f","962":"5397ec9a"}[chunkId] + ".chunk.js";
};